module.exports = __webpack_public_path__ + "img/new-k-plus-logo.185666db.png";